import * as c from '../../../constants/Constants'
const createjs = window.createjs

export const changeContainerX = (x, stage, container, container_up, setScrollPosition) => {
  const sc = stage.scaleX;
  const sx = stage.x;
  const iw = window.document.documentElement.clientWidth;
  const scw = iw/c.CAN_W

  const ctwh = c.CT_W / 2;
  const ctwhMin = ctwh * sc;
  const ctwhSa = (ctwh - ctwhMin);
  const iwh = iw / 2;
  let min = (ctwh - iwh) - (ctwhSa * 1.2);
  let max = (-ctwh + iwh)
  // console.log(iw)
  
  // console.log(x, min, max);
  const _x = x;
  x = Math.min(x, min);
  x = Math.max(x, max);
  // console.log(min, max, x, scw, stage.scaleX, stage.x);
  if(iw >= c.CT_W) {
    x = 0;
    if(setScrollPosition) {
      setScrollPosition(true, false, true);
    }
    
  } else {
    let isMin = true;
    let isMax = true;
    if(_x <= min) {
      isMin = false;
    }
    if(_x >= max) {
      isMax = false;
    }
    if(setScrollPosition) {
      setScrollPosition(false, isMin, isMax);
    }
  }
  if (container.x !== x) {
    container.x = x
    container_up.x = x
  }
};

export const tweenContainerX = (x, stage, container, container_up, setScrollPosition) => {
  const sc = stage.scaleX;
  const sx = stage.x;
  const iw = window.document.documentElement.clientWidth;
  const scw = iw/c.CAN_W

  const ctwh = c.CT_W / 2;
  const ctwhMin = ctwh * sc;
  const ctwhSa = (ctwh - ctwhMin);
  const iwh = iw / 2;
  let min = (ctwh - iwh) - (ctwhSa * 1.2);
  let max = (-ctwh + iwh)
  // console.log(iw)

  // console.log(x, min, max);
  const _x = x;
  x = Math.min(x, min);
  x = Math.max(x, max);
  // console.log(min, max, x, scw, stage.scaleX, stage.x);
  if(iw >= c.CT_W) {
    x = 0;
    if(setScrollPosition) {
      setScrollPosition(true, false, true);
    }
    if (container.x !== x) {
      container.x = x
      container_up.x = x
    }

  } else {
    if (container.x !== x) {
      createjs.Tween.removeTweens(container)
      createjs.Tween.removeTweens(container_up)
      createjs.Tween.get(container).to({x},1000,createjs.Ease.quartOut)
      createjs.Tween.get(container_up).to({x},1000,createjs.Ease.quartOut).call(()=>{
        let isMin = true;
        let isMax = true;
        if(_x <= min) {
          isMin = false;
        }
        if(_x >= max) {
          isMax = false;
        }
        if(setScrollPosition) {
          setScrollPosition(false, isMin, isMax);
        }
      })
    }
  }
  
};



/** WEBPACK FOOTER **
 ** ./src/components/canvas/util/Utils.js
 **/